<template>
  <a class="skip-main" href="#main">Skip to main content</a>
  <fis-masthead @impersonate-user="impersonateUser()"></fis-masthead>
  <div class="container-fluid">
    <div v-if="this.appReady">
      <router-view/>
    </div>
    <div v-else>{{ this.loadingStatus }}</div>
  </div>
  <fis-error-modal />
</template>

<script>
import { mapGetters } from 'vuex';
import router from '@/router';
import fisMasthead from '@/components/fisMasthead.vue';
import FisErrorModal from '@/components/fisErrorModal.vue';
import { Modal } from 'bootstrap';
import { User } from './assets/js/fisUser_v1';
import { NamedPair } from './assets/js/fisNamedPair_v1';
import { FetchBuilder } from './assets/js/fisFetchBuilder_v1';

export default {
  components: { FisErrorModal, fisMasthead },
  computed: {
    ...mapGetters([
      'application',
      'user',
      'token',
      'fetchPath',
      'appReady',
      'loadingStatus',
      'impersonateNetId',
      'buildings',
      'query',
    ]),
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    initialize() {
      // add the links
      this.$store.dispatch('addUserLinks');
      // handles if we need to move to a different route just take the default
      this.handleRoute();

      // set statuses
      this.$store.commit('loginReady', true);

      // go back to the server to get costCenters and model for user
      this.initializeUser();

      // get buildings
      this.initializeBuildings();

      // this.isReady();
      // console.log("ready? " + this.$store.commit("loadingStatus", "Ready."));
      // this.$store.commit("loadingStatus", "Ready.");
    },
    initializeUser() {
      this.$store.commit('loadingStatus', 'Initialize User...');

      const app = this;
      const parameters = [];
      parameters.push(new NamedPair('token', app.token));

      const fetchBuilder = new FetchBuilder(
        'GET',
        app.fetchPath('user'),
        parameters,
      );

      fetch(fetchBuilder.url, fetchBuilder.toFetchOptions())
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          if (response.status === 'SUCCESS') {
            this.$store.commit('user', new User(response.payload));
            // console.log(this.user);
            this.$store.commit('loadingStatus', 'User...Successful');
            this.isReady();
            if (this.user.hasRole('user')) {
              router.push({ path: '/search' });
            } else {
              router.push({ path: '/access' });
            }
          } else {
            app.$store.commit('errorObject', {
              title: 'ERROR : Getting User',
              body: response.message,
            });
            const errorModal = new Modal(
              document.getElementById('errorModal'),
              {},
            );
            errorModal.show();
            // console.log(response);
          }
        });
    },
    initializeBuildings() {
      this.$store.commit('loadingStatus', 'Initialize Buildings...');

      const app = this;
      const parameters = [];
      parameters.push(new NamedPair('token', app.token));

      const fetchBuilder = new FetchBuilder(
        'GET',
        app.fetchPath('building'),
        parameters,
      );

      fetch(fetchBuilder.url, fetchBuilder.toFetchOptions())
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          if (response.status === 'SUCCESS') {
            app.$store.commit('buildings', response.payload);
            this.isReady();
          } else {
            app.$store.commit('errorObject', {
              title: 'ERROR : Getting Buildings',
              body: response.message,
            });
            const errorModal = new Modal(
              document.getElementById('errorModal'),
              {},
            );
            errorModal.show();
            // console.log(response);
          }
        });
    },
    initializeNonUser() {
      router.push({ path: '/access' });
    },
    handleRoute() {
      const routes = [];
      router.getRoutes().forEach((r) => {
        // console.log("adding " + r.path);
        routes.push(r.path);
      });
      // console.log(this.currentRouteName);
      if (!routes.includes(`/${this.currentRouteName}`)) {
        // console.log("not found pushing route /labor");
        router.push({ path: '/batching' });
      }
    },
    impersonateUser() {
      // console.log(this.impersonateNetId);

      const app = this;
      const parameters = [];
      parameters.push(new NamedPair('token', app.token));
      parameters.push(new NamedPair('netId', this.impersonateNetId));

      const fetchBuilder = new FetchBuilder(
        'GET',
        app.fetchPath('impersonate'),
        parameters,
      );

      fetch(fetchBuilder.url, fetchBuilder.toFetchOptions())
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          if (response.status === 'SUCCESS') {
            app.$store.commit('user', response.payload);
            this.initialize();
          } else {
            app.$store.commit('errorObject', {
              title: 'ERROR : OvertimeRequest',
              body: response.message,
            });
            const errorModal = new Modal(
              document.getElementById('errorModal'),
              {},
            );
            errorModal.show();
            // console.log(response);
          }
        });
    },
    isReady() {
      if (this.buildings.length > 0
        && this.user.person !== 'undefined'
        && this.user.person.email !== 'undefined') { this.$store.commit('appReady', true); }
    },
  },
  created() {
    // console.log(this.application.name);
    // console.log(this.user);
    this.$store.commit('baseUrl', new URL(document.location.href));
    this.user = new User();
    this.query.addFilterItem('effectiveStatus', 'active', 1);
    this.query.addFilterItem('w.category', 'PREVENT MAINT', 4);
    this.query.addSortItem('w.proposal', 'DESC');
  },
  mounted() {
    this.$store.commit('loadingStatus', 'Authenticating...');
    if (this.$store.getters.haveUrlParameter('ticket')) {
      // console.log('ticket');

      const parameters = [];
      parameters.push(new NamedPair('action', 'AUTHENTICATE'));
      parameters.push(
        new NamedPair('ticket', (this.$store.getters.getUrlParameter('ticket'))),
      );
      parameters.push(
        new NamedPair('originationUrl', this.$store.getters.originationUrl),
      );

      const fetchBuilder = new FetchBuilder(
        'GET',
        this.$store.getters.fetchPath('authenticate'),
        parameters,
      );
      // console.log(fetchBuilder.url);
      fetch(fetchBuilder.url, fetchBuilder.toFetchOptions())
        .then((response) => response.json())
        .then((response) => {
          if (response.status === 'SUCCESS') {
            // need to get rid of the ticket on the url so just go back to authentication one more
            // time. the cas variable should be there to stop the process and return the user
            // window.location.href = app.originationUrl;

            this.$store.commit('user', new User(response.payload));
            // console.log(this.user);

            // remove the ticket from the url
            this.$store.dispatch('removeTicketFromURL');

            // change the loading status
            this.$store.commit('loadingStatus', 'User established.');
            this.initialize();
          } else {
            // console.log("no ticket failure - not CAS");
            console.log(response);
          }
        });
    } else {
      // console.log('no ticket');
      // console.log(`token: ${this.user.token}`);
      // no ticket so try to authenticate

      const parameters = [];
      if (this.user.token != null && this.user.token != 'MISSING') parameters.push(new NamedPair('token', this.token));

      const fetchBuilder = new FetchBuilder(
        'GET',
        this.$store.getters.fetchPath('authenticate'),
        parameters,
      );
      console.log(fetchBuilder.url);
      fetch(fetchBuilder.url, fetchBuilder.toFetchOptions())
        .then((response) => response.json())
        .then((response) => {
          if (response.status === 'SUCCESS') {
            // really should not happen but just in case ...
            // console.log("no ticket success ");
            this.$store.commit('user', new User(response.payload));

            // change the loading status
            this.$store.commit('loadingStatus', 'User established.');

            if (!this.user.hasRole('user')) {
              this.initializeNonUser();
            } else {
              // console.log('non user no ticket');
              this.initialize();
            }
          } else if (response.message == 'CAS_VARIABLE_NOT_FOUND') {
            // this means we need to CASify so use the string found in data to redirect
            const uri = `${response.payload
            }?service=${
              this.$store.getters.originationUrl}`;
            // console.log(`authentication redirect : ${uri}`);
            document.location.href = uri;
          } else {
            // console.log("no ticket failure - not CAS");
            // showModalError('Request could not be completed.', response.message);
          }
        });
    }
  },
};

</script>
<style>
#app {
  margin-top: 60px;
}
a.skip-main {
  left:-999px;
  position:absolute;
  top:auto;
  width:1px;
  height:1px;
  overflow:hidden;
  z-index:-999;
}
a.skip-main:focus, a.skip-main:active {
  color: #fff;
  background-color:#000;
  left: auto;
  top: auto;
  width: 30%;
  height: auto;
  overflow:auto;
  margin: 10px 35%;
  padding:5px;
  border-radius: 15px;
  border:4px solid yellow;
  text-align:center;
  font-size:1.2em;
  z-index:999;
}
</style>
